import { useQuery } from '@tanstack/react-query';

import { GetLogoutResponse } from '@/api/userAccount/types';
import { axios } from '@/common/axios';
import { ExtractFnReturnType, QueryConfig, queryClient } from '@/common/react-query';

export const getLogout = async (): Promise<GetLogoutResponse> => {
    const logoutResponse = await axios.get<GetLogoutResponse, GetLogoutResponse>(`/logout`);
    queryClient.invalidateQueries({ queryKey: ['validate-data-connection'] });
    return logoutResponse;
};

type QueryFnType = typeof getLogout;

type UseLogoutOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useLogout = ({ config = {} }: UseLogoutOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['logout'],
        queryFn: getLogout,
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
